import { useConstants } from 'composables/useConstants.js'

export default {
  data() {
    // Called after turbo:load sets window globals — safe to read them here.
    const { parseLocale, ...constants } = useConstants()
    return { ...constants }
  },
  methods: {
    parseLocale(locale, dataObject) {
      return useConstants().parseLocale(locale, dataObject)
    },
  },
}
